import { get } from 'common/apiClient';

export type RolePayload = {
  roleId: string;
  access: string;
};

export type MenuPayload = {
  menuName: String;
  url: String;
  key: String;
  subMenu: [];
};
export type MenuPagedResponse = {
  data: MenuList;
};

export type MenuList = {
  menu: MenuItem[];
};
export type MenuItem = {
  menuName: String;
  url: String;
  key: String;
  submenu?: MenuItem[];
};

export const getMenu = (payload?: string) =>
  get<MenuPagedResponse>('/usermanagement/getMenuByRole?roleId=' + payload);
